import { ApolloError } from '@apollo/client';
import { useEffect } from 'react';
import { enqueueSnackbar } from 'notistack';

export function useHandledSubscription<T extends {error?: ApolloError | undefined, restart: () => void}>(res: T) {
  const {error, restart} = res;

  useEffect(() => {
    if (error) {
      console.error(error);
      enqueueSnackbar({variant: 'error', message: error.message})
      setTimeout(() => restart(), 60000)
    }
  }, [error, restart]);

  return res
}
